import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtJMD, formatApiError } from "../../lib/api";

export default function AdminFlavours() {
  const [items, setItems] = useState([]);
  const [config, setConfig] = useState({ price_per_pop: 650, min_pops: 4, max_pops: 24, default_pops: 8 });

  const load = async () => {
    setItems((await api.get("/products?active_only=false")).data);
    setConfig((await api.get("/build-a-box/config")).data);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (p) => {
    try {
      await api.put(`/products/${p.id}`, { ...p, available_for_build_a_box: !p.available_for_build_a_box });
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const saveConfig = async () => {
    try {
      await api.put("/build-a-box/config", {
        price_per_pop: Number(config.price_per_pop),
        min_pops: Number(config.min_pops),
        max_pops: Number(config.max_pops),
        default_pops: Number(config.default_pops),
      });
      toast.success("Config updated");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="admin-flavours">
      <div className="overline text-zinc-500">Build Yuh Own Box</div>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-6">Flavour availability & pricing</h1>

      <div className="rounded-xl border border-zinc-200 bg-white p-5 sm:p-6 mb-6">
        <div className="font-display font-bold mb-4">Box configuration</div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
          <L label="Price / pop (JMD)"><input type="number" className="input" value={config.price_per_pop} onChange={(e) => setConfig({ ...config, price_per_pop: e.target.value })} data-testid="cfg-price" /></L>
          <L label="Minimum pops"><input type="number" className="input" value={config.min_pops} onChange={(e) => setConfig({ ...config, min_pops: e.target.value })} data-testid="cfg-min" /></L>
          <L label="Maximum pops"><input type="number" className="input" value={config.max_pops} onChange={(e) => setConfig({ ...config, max_pops: e.target.value })} data-testid="cfg-max" /></L>
          <L label="Default pops"><input type="number" className="input" value={config.default_pops} onChange={(e) => setConfig({ ...config, default_pops: e.target.value })} data-testid="cfg-default" /></L>
        </div>
        <button onClick={saveConfig} className="btn-primary mt-5" data-testid="save-config-btn">Save config</button>
      </div>

      <div className="rounded-xl border border-zinc-200 bg-white overflow-hidden">
        <div className="p-5 font-display font-bold border-b border-zinc-100">Flavours in Build Yuh Own Box</div>
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[600px]">
          <thead className="bg-zinc-50 text-zinc-500 text-xs">
            <tr><th className="text-left px-5 py-3">Flavour</th><th className="text-left px-5 py-3">Price</th><th className="text-left px-5 py-3">Stock</th><th className="text-right px-5 py-3">Available</th></tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-t border-zinc-100">
                <td className="px-5 py-3 font-semibold">{p.name}</td>
                <td className="px-5 py-3">{fmtJMD(p.price)}</td>
                <td className="px-5 py-3">{p.stock}</td>
                <td className="px-5 py-3 text-right">
                  <label className="inline-flex items-center gap-2">
                    <input type="checkbox" checked={p.available_for_build_a_box} onChange={() => toggle(p)} data-testid={`toggle-${p.id}`} />
                    <span className="text-xs">{p.available_for_build_a_box ? "On" : "Off"}</span>
                  </label>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
      <style>{`.input { width:100%; border:1px solid #e4e4e7; border-radius:0.5rem; padding:0.5rem 0.75rem; }`}</style>
    </div>
  );
}
function L({ label, children }) { return <div><label className="text-xs font-semibold text-zinc-600 block mb-1">{label}</label>{children}</div>; }
